
import { HGap } from './UI';

import * as Game from './copied/Game';

export function PlayerSummary({ user } : { user: Game.Player }) {
	const dead = user.health <= 0;

	return <>
		<div><b>{dead && '[Dead] '} {user.nickname}</b></div>
		<div>
			{!dead && <>
				HP: {user.health} <HGap />
				AP: {user.actionPoints} <HGap />
			</>}
			range: {user.range}
		</div>
		<div>
			{dead
			? <>Votes available: {user.votesAvailable}</>
			: <>Votes received: {user.votesReceived}</>
			}
		</div>
	</>;
}
